import { useState } from "react";
import "../App.css";

import copyIcon from "../assets/images/copy.png";
import cartIcon from "../assets/images/cart.png";
import chartIcon from "../assets/images/chart.png";

const contract =
    "0xSkyGooseCA1234567890abcdef1234567890abcdef12";

const shortContract =
    `${contract.slice(0, 10)}...${contract.slice(-8)}`;

function FooterBar() {

    const [copied, setCopied] = useState(false);

    const copyContract = async () => {

        try {

            if (navigator.clipboard && window.isSecureContext) {

                await navigator.clipboard.writeText(contract);

            } else {

                const textArea = document.createElement("textarea");

                textArea.value = contract;

                textArea.style.position = "fixed";
                textArea.style.left = "-9999px";
                textArea.style.top = "-9999px";

                document.body.appendChild(textArea);

                textArea.focus();
                textArea.select();

                document.execCommand("copy");

                document.body.removeChild(textArea);

            }

            setCopied(true);

            setTimeout(() => {

                setCopied(false);

            }, 2000);

        } catch {

            alert("Copy failed. Please copy manually.");

        }

    };

    return (

        <section className="footer-bar">

            <div className="container">

                <div className="footer-box">

                    <div className="footer-item">

                        <span>TICKER</span>

                        <h3>$GOOSE</h3>

                    </div>

                    <div className="footer-item contract">

                        <span>CONTRACT</span>

                        <div className="contract-row">

                            <p>{shortContract}</p>

                            <button
                                onClick={copyContract}
                                className="copy-btn"
                            >

                                <img
                                    src={copyIcon}
                                    alt=""
                                />

                            </button>

                        </div>

                        {
                            copied &&
                            <small className="copied">
                                Contract Copied!
                            </small>
                        }

                    </div>

                    <div className="footer-item">

                        <span>CHAIN</span>

                        <h3>BNB CHAIN</h3>

                    </div>

                    <div className="footer-actions">

                        <a
                            href="#"
                            className="buy-goose-btn"
                        >

                            BUY

                            <img
                                src={cartIcon}
                                alt=""
                            />

                        </a>

                        <a
                            href="#"
                            className="chart-btn"
                        >

                            CHART

                            <img
                                src={chartIcon}
                                alt=""
                            />

                        </a>

                    </div>

                </div>

            </div>

        </section>

    );

}

export default FooterBar;